import type { ReactNode } from "react";

/**
 * Sprint 29.3 Wave F / Sprint 60 — locale flag glyphs as inline SVG (Unicode
 * regional-indicator emoji do not render on Chromium-on-Windows).
 *
 * E-BUNDLE-22: aus `AppShell.tsx` herausgeloest, damit die Topbar-Schaltflaeche
 * und das nachgeladene Auswahlmenue (`LanguageMenuPanel.tsx`) dieselbe Tabelle
 * benutzen, ohne dass die Glyphen doppelt gebuendelt werden.
 */

function FlagGB() {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 60 30"
      aria-hidden
      style={{ display: "block", borderRadius: 2 }}
    >
      <rect width="60" height="30" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="2" />
      <path d="M30,0 V30 M0,15 H60" stroke="#fff" strokeWidth="10" />
      <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6" />
    </svg>
  );
}

function FlagDE() {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 60 30"
      aria-hidden
      style={{ display: "block", borderRadius: 2 }}
    >
      <rect width="60" height="10" fill="#000" />
      <rect y="10" width="60" height="10" fill="#DD0000" />
      <rect y="20" width="60" height="10" fill="#FFCE00" />
    </svg>
  );
}

function FlagFR() {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 60 30"
      aria-hidden
      style={{ display: "block", borderRadius: 2 }}
    >
      <rect width="20" height="30" fill="#002395" />
      <rect x="20" width="20" height="30" fill="#fff" />
      <rect x="40" width="20" height="30" fill="#ED2939" />
    </svg>
  );
}

function FlagSA() {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 60 30"
      aria-hidden
      style={{ display: "block", borderRadius: 2 }}
    >
      <rect width="60" height="30" fill="#006C35" />
      <rect x="14" y="20" width="32" height="2" fill="#fff" />
    </svg>
  );
}

export const LOCALE_FLAGS: Readonly<Record<string, () => ReactNode>> = {
  en: FlagGB,
  de: FlagDE,
  fr: FlagFR,
  ar: FlagSA,
};
